export default __webpack_public_path__ + "static/media/save-money.4dff2359.svg";